import React, { useState, useEffect } from 'react';
import { Redirect, useParams, useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SubHeader from '../../components/global/SubHeader';
import Loader from '../../components/global/Loader';

// import SwiperCore, { Navigation } from 'swiper';
// import { Swiper, SwiperSlide } from 'swiper/react';
// import 'swiper/swiper.scss';
// import 'swiper/components/navigation/navigation.scss';

import { getItemDetail, updateItem, getStables } from '../../libs/apis';

// SwiperCore.use([Navigation]);

export default function EditItemBillingPage() {
  const { t } = useTranslation();
  const { horseId } = useParams();
  const history = useHistory();
  const initialState = {
    data: [],
    isLoading: false,
    isError: false,
    message: '',
    image: null,
    isLoadingStable: false,
    isErrorStable: false,
    messageStable: '',
    isDeleting: false,
    isDeleteError: false,
    deleteMessage: false,
    isEditStable: false,
    stableData: [],
    selectedStable: -1,
    isSubmit: false,
    isSubmitError: false,
    isUploadError: false,
    isUploading: false,
    isOpen: false,
    hasInput: false,
    warningEmail: false,
    isBillingActive: false,
    billingEmail: '',
    billingName: '',
    billingCompanyId: '',
    billingAddress: '',
    billingPhone: '',
  };
  const [state, setMyState] = useState(initialState);
  const setState = newState => {
    setMyState(prevState => ({ ...prevState, ...newState }));
  };
  const {
    data,
    isLoading,
    isError,
    // isLoadingStable,
    // isErrorStable,
    hasInput,
    warningEmail,
    isBillingActive,
    billingEmail,
    billingName,
    billingCompanyId,
    billingAddress,
    billingPhone,
    // isSubmitError
  } = state;

  useEffect(() => {
    const getItemData = async () => {
      setState({ isLoading: true, isError: false, message: '' });
      const payload = {
        id: horseId,
      };
      await getItemDetail(payload)
        .then(resp => {
          if (resp.status === 200) {
            setState({
              data: resp.data.response,
              image: resp.data.response.image,
            });
            setState({
              billingEmail: resp.data.response.billing_email || '',
              billingName: resp.data.response.billing_name || '',
              billingCompanyId: resp.data.response.billing_company_id || '',
              billingAddress: resp.data.response.billing_address || '',
              billingPhone: resp.data.response.billing_phone || '',
            });
            if (resp.data.response.stable) {
              setState({ selectedStable: resp.data.response.stable.id });
            }
            if (resp.data.response.billing_active) {
              setState({ isBillingActive: resp.data.response.billing_active });
            }
          } else {
            setState({ isError: true, message: resp.data.error.message });
          }
        })
        .catch(err => {
          console.log('err', err);
          setState({ isError: true, message: err.error.message });
        })
        .finally(() => setState({ isLoading: false }));
    };
    const getStableData = async () => {
      setState({
        isLoadingStable: true,
        isErrorStable: false,
        messageStable: '',
      });
      await getStables()
        .then(resp => {
          if (resp.status === 200) {
            setState({ stableData: resp.data.response });
          } else {
            setState({
              isErrorStable: true,
              messageStable: resp.data.error.message,
            });
          }
        })
        .catch(err => {
          console.log('err', err);
          // setState({ isErrorStable: true, messageStable: err.error.message });
        })
        .finally(() => setState({ isLoadingStable: false }));
    };
    getItemData();
    getStableData();
  }, [horseId]);

  if (!horseId) return <Redirect to="/profile" />;
  if (isLoading) return <Loader size="48" center />;
  if (isError) return <p>Error</p>;

  const { billing_email } = data;

  const updateHorse = async () => {
    setState({ isSubmit: true, isSubmitError: false, submitMessage: '' });
    const payload = data;
    payload.stable_id = data.stable.id;
    payload.category_id = data.category.id;
    payload.billing_active = isBillingActive;
    if (isBillingActive) {
      payload.billing_email = billingEmail;
      payload.billing_name = billingName;
      payload.billing_company_id = billingCompanyId;
      payload.billing_address = billingAddress;
      payload.billing_phone = billingPhone;
    }
    await updateItem(payload)
      .then(resp => {
        if (resp.status === 200) {
          setState({ data: resp.data.response });
          setTimeout(() => {
            history.push(`/horse/${horseId}`);
          }, 1000);
        }
      })
      .catch(err => {
        console.log('err', err);
        setState({ isSubmitError: true });
      })
      .finally(() => setState({ isSubmit: false }));
  };

  return (
    <div className="app-container">
      <SubHeader
        title={t('horse_detail_title')}
        go={`/horse/${horseId}`}
        prevent={hasInput}
      >
        {!isBillingActive ||
        (isBillingActive && billingEmail && billingEmail !== '') ? (
          <button onClick={updateHorse} className="btn text-primary">
            {t('save_horse_button')}
          </button>
        ) : (
          <button type="button" className="btn text-secondary" disabled>
            {t('save_horse_button')}
          </button>
        )}
      </SubHeader>

      <div className="container mt-3 mb-5">
        <div className="row justify-content-center">
          <div className="col-12">
            <div className="main-content">
              <div className="mb-3 d-flex justify-content-between align-items-center">
                <h6 className="fw-bold">{t('enable_billing_info_label')}</h6>
                <div className="form-check form-switch mb-0">
                  <input
                    className="form-check-input"
                    type="checkbox"
                    id="enable_billing"
                    checked={isBillingActive}
                    onChange={e => {
                      setState({ isBillingActive: e.target.checked });
                      if (e.target.checked && billing_email === '') {
                        setState({ warningEmail: true });
                      } else {
                        setState({ warningEmail: false });
                      }
                    }}
                  />
                  {/* <label
                              className="form-check-label fs-14 fw-bold"
                              for="enable_billing"
                            >
                              {t('billing_info_enable_label')}
                            </label> */}
                </div>
              </div>

              <div
                className={`billing-info-container ${
                  isBillingActive ? '' : 'opacity-50'
                }`}
              >
                <>
                  <div className="form-group mb-2 mt-3">
                    <label className="fs-14" htmlFor="billing_email">
                      {t('billing_info_email')}
                      <span className="text-danger">*</span>
                    </label>

                    {isBillingActive ? (
                      <input
                        type="email"
                        className={`form-control  ${
                          warningEmail ? 'is-invalid' : ''
                        }`}
                        required
                        id="billing_email"
                        name="billing_email"
                        value={billingEmail}
                        onChange={e => {
                          setState({ billingEmail: e.target.value });
                          if (e.target.value !== '') {
                            setState({ warningEmail: false });
                          } else {
                            setState({ warningEmail: true });
                          }
                        }}
                      />
                    ) : (
                      <input
                        type="email"
                        className="form-control"
                        value={billingEmail}
                        id="billing_email"
                        name="billing_email"
                        onChange={e =>
                          setState({ billingEmail: e.target.value })
                        }
                      />
                    )}
                    {warningEmail && (
                      <div className=" fs-12 invalid-feedback">
                        {t('billing_info_email_invalid')}
                      </div>
                    )}
                  </div>

                  <div className="billing-data">
                    <div className="form-group mb-2">
                      <label className="fs-14" htmlFor="billing_name">
                        {t('billing_info_name')}
                      </label>

                      <input
                        type="text"
                        className="form-control "
                        id="billing_name"
                        name="billing_name"
                        value={billingName}
                        onChange={e => {
                          setState({
                            billingName: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="billing-data">
                    <div className="form-group mb-2">
                      <label className="fs-14" htmlFor="billing_company_id">
                        {t('billing_info_company_id')}
                      </label>

                      <input
                        type="text"
                        className="form-control "
                        id="billing_company_id"
                        name="billing_company_id"
                        value={billingCompanyId}
                        onChange={e => {
                          setState({
                            billingCompanyId: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="billing-data">
                    <div className="form-group mb-2">
                      <label className="fs-14" htmlFor="billing_address">
                        {t('billing_info_address')}
                      </label>

                      <input
                        type="text"
                        className="form-control "
                        id="billing_address"
                        name="billing_address"
                        value={billingAddress}
                        onChange={e => {
                          setState({
                            billingAddress: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>

                  <div className="billing-data">
                    <div className="form-group mb-3">
                      <label className="fs-14" htmlFor="billing_phone">
                        {t('billing_info_phone')}
                      </label>

                      <input
                        type="text"
                        className="form-control "
                        id="billing_phone"
                        name="billing_phone"
                        value={billingPhone}
                        onChange={e => {
                          setState({
                            billingPhone: e.target.value,
                          });
                        }}
                      />
                    </div>
                  </div>
                </>

                {/* <div className="form-group mb-2">
                        <div className="row g-2">
                          <div className="col-4">
                            <label className="fs-14" htmlFor="billing_email">
                              Billing Name:
                            </label>
                          </div>
                          <div className="col-8">
                            <input
                              type="text"
                              className="form-control "
                              value={billing_name}
                              onChange={e =>
                                setState({ billing_name: e.target.value })
                              }
                            />
                          </div>
                        </div>
                      </div> */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
